import {
  CommunityPost as UsCommunityPostPb,
  CommunityProfile as UsCommunityProfilePb,
} from "@repo/protobuf/gen/web/public/community_pb";
import kikoffAdminApi from "@repo/rest/kikoffAdminApi";
import RestApi from "@repo/rest/RestApi";

type CommunityProfile = {
  id: CommunityProfile.Id;
  displayName: string;
  creditScore: CommunityProfile.CreditScore;
  showScore: boolean;
  isAdmin: boolean;
};

namespace CommunityProfile {
  export type Id = `cpr_${string}`;
  export type Summary = Pick<
    CommunityProfile,
    "id" | "displayName" | "creditScore" | "isAdmin"
  >;
  export type CreditScore = 300 | 400 | 500 | 600 | 700 | 800 | null;
  export const toSummary = (
    profile: CommunityProfile
  ): CommunityProfile.Summary => ({
    id: profile.id,
    displayName: profile.displayName,
    creditScore: profile.showScore ? profile.creditScore : null,
    isAdmin: profile.isAdmin,
  });
}

export default CommunityProfile;

export namespace CommunityProfileUsa {
  export function normalize(profile: UsCommunityProfilePb): CommunityProfile {
    return {
      ...Summary.normalize(profile),
      showScore: profile.showScore,
      isAdmin: profile.isAdmin,
    };
  }

  export namespace Summary {
    export function normalize(
      profile: UsCommunityPostPb.Profile
    ): CommunityProfile.Summary {
      return {
        id: profile.token as CommunityProfile.Id,
        displayName: profile.displayName,
        creditScore: profile.creditScore as CommunityProfile.CreditScore,
        isAdmin: profile.isAdmin,
      };
    }
  }
}

export namespace CommunityProfileUsaAdmin {
  export function normalize(
    profile: RestApi.ResponseOf<
      (typeof kikoffAdminApi)["community"]["profile"]["POST"]
    >["profile"]
  ): CommunityProfile {
    return {
      ...Summary.normalize(profile),
      showScore: false,
      isAdmin: false,
    };
  }
  export namespace Summary {
    export function normalize(
      profile: RestApi.ResponseOf<
        (typeof kikoffAdminApi)["community"]["profile"]["POST"]
      >["profile"]
    ): CommunityProfile.Summary {
      return {
        id: profile.token as CommunityProfile.Id,
        displayName: profile.displayName,
        creditScore: null,
        isAdmin: false,
      };
    }
  }
}
